import { Component } from '@angular/core';

@Component({
  selector: 'app-p-qr',
  templateUrl: './p-qr.component.html',
  styleUrls: ['./p-qr.component.css']
})
export class PQRComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
